export type Testimonial = {
  quote: string
  author: string
  role: string
  location: string
  /** Photo URL, shared with the coach's permission. Empty = initials. */
  avatar?: string
}

/**
 * Real, permissioned coach reviews only. No result claims (wins, pins, weight).
 */
export const testimonials: Testimonial[] = [
  {
    quote:
      'I can coach both tracks without constantly stopping one group to catch up the other.',
    author: 'James K.',
    role: 'Head Coach, Riverside High School Wrestling',
    location: 'London, UK',
  },
  {
    quote:
      'The two-track setup gives beginners a clear path while experienced wrestlers keep working.',
    author: 'Alex M.',
    role: 'Club Wrestling Coach, Westside Wrestling Club',
    location: 'Sydney, Australia',
  },
  {
    quote:
      'The clock keeps the practice moving and makes transitions much more straightforward.',
    author: 'Chris D.',
    role: 'Middle School Wrestling Coach, Central Wrestling',
    location: 'Denver, Colorado, USA',
  },
]
